import gql from 'graphql-tag'

const productFeaturesGetQuery = gql`
  query productFeaturesGet($offset: Int, $limit: Int, $criteria: Object, $sorting: Object) {
    productFeaturesGet(input: { limit: $limit, offset: $offset, criteria: $criteria, sort: $sorting, nested: false })
      @rest(type: "productFeaturesGetQuery", method: "POST", path: "product-feature/list") {
      results
    }
  }
`

export default productFeaturesGetQuery
